import React, { useEffect, useState } from "react";

const Home = () => {
  const [ciphers, setCiphers] = useState([]);
  const [selectedCiphers, setSelectedCiphers] = useState([]);
  const [searchNumber, setSearchNumber] = useState("");
  const [results, setResults] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [textFilter, setTextFilter] = useState("");

  const pageSize = 10;

  // Load cipher options from API
  useEffect(() => {
    const fetchCiphers = async () => {
      try {
        const res = await fetch("/api/ciphers");
        const data = await res.json();
        setCiphers(data);
        setSelectedCiphers(data.map((c) => c.id)); // Default: all selected
      } catch (err) {
        console.error("Failed to load ciphers", err);
      }
    };

    fetchCiphers();
  }, []);

  // Handle checkbox changes
  const toggleCipher = (id) => {
    setSelectedCiphers((prev) =>
      prev.includes(id) ? prev.filter((cid) => cid !== id) : [...prev, id]
    );
  };

  // Fetch paginated results
  const fetchResults = async (page = 1) => {
    try {
      const params = new URLSearchParams({
        number: searchNumber,
        page,
        pageSize,
        cipherIds: selectedCiphers.join(","),
      });

      if (textFilter.trim()) {
        params.append("textFilter", textFilter.trim());
      }

      const res = await fetch(`/api/phrases/search?${params.toString()}`);
      const data = await res.json();
      setResults(data.results);
      setTotalCount(data.total_results);
    } catch (err) {
      console.error("Error fetching results", err);
    }
  };

  // On form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchResults(1);
  };

  // Handle pagination changes
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchResults(newPage);
  };

  // Split ciphers into columns of 10
  const chunkedCiphers = [];
  for (let i = 0; i < ciphers.length; i += 10) {
    chunkedCiphers.push(ciphers.slice(i, i + 10));
  }

  const selectAllCiphers = () => {
    setSelectedCiphers(ciphers.map((c) => c.id));
  };

  const selectBaseCiphers = () => {
    setSelectedCiphers([1, 2, 3, 4]);
  };

  const clearCiphers = () => {
    setSelectedCiphers([]);
  };

  return (
    <div style={{ padding: "1rem" }}>
      <h2>Gematria Search</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="number"
          value={searchNumber}
          onChange={(e) => setSearchNumber(e.target.value)}
          placeholder="Enter number"
          required
        />
        <input
          type="text"
          value={textFilter}
          onChange={(e) => setTextFilter(e.target.value)}
          placeholder="Phrase must contain..."
          style={{ marginLeft: "0.5rem" }}
        />
        <button type="submit" style={{ marginLeft: "0.5rem" }}>
          Search
        </button>
      </form>

      <div style={{ marginTop: "1rem" }}>
        <h3>Select Ciphers</h3>
        <div style={{ marginBottom: "0.5rem" }}>
          <button
            type="button"
            onClick={selectBaseCiphers}
            style={{ marginRight: "0.5rem" }}
          >
            Select Base
          </button>
          <button
            type="button"
            onClick={selectAllCiphers}
            style={{ marginRight: "0.5rem" }}
          >
            Select All
          </button>
          <button type="button" onClick={clearCiphers}>
            Clear Selections
          </button>
        </div>
        <div style={{ display: "flex", gap: "2rem", flexWrap: "wrap" }}>
          {chunkedCiphers.map((group, colIdx) => (
            <ul key={colIdx} style={{ listStyle: "none", padding: 0 }}>
              {group.map((cipher) => (
                <li key={cipher.id}>
                  <label>
                    <input
                      type="checkbox"
                      checked={selectedCiphers.includes(cipher.id)}
                      onChange={() => toggleCipher(cipher.id)}
                    />{" "}
                    {cipher.name}
                  </label>
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>

      <div style={{ marginTop: "2rem" }}>
        <h3>Results</h3>
        {results.length === 0 ? (
          <p>No results to display</p>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th
                  style={{
                    borderBottom: "1px solid #ccc",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  Phrase
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #ccc",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  Cipher
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #ccc",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  Gematria Value
                </th>
              </tr>
            </thead>
            <tbody>
              {results.map((result, idx) => (
                <tr key={idx}>
                  <td style={{ padding: "8px" }}>{result.phraseText}</td>
                  <td style={{ padding: "8px" }}>{result.cipher}</td>
                  <td style={{ padding: "8px" }}>{result.gematriaValue}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {totalCount > 0 && (
          <div style={{ marginTop: "1rem" }}>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Prev
            </button>
            <span style={{ margin: "0 1rem" }}>
              Page {currentPage} of {Math.ceil(totalCount / pageSize)}
            </span>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage * pageSize >= totalCount}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
